<template>
  <div>
    <FullCalendar ref="fullCalendar" :options="calendarOptions" class="tw-mb-8"/>

    <CreateModal :portal="portal" :from="creatingFrom" :to="creatingTo" @created="created"/>

    <EditModal :content-article-flag-schedule="editing" @updated="updated" @deleted="deleted"/>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/vue'
import LoadingContainer from "../../../../../../../components/Layout/LoadingContainer.vue";
import CreateModal from "../../../../../../../components/Administration/ContentArticleFlagSchedules/Modals/Create"
import EditModal from "../../../../../../../components/Administration/ContentArticleFlagSchedules/Modals/Edit"

export default {
  components: {CreateModal, EditModal, LoadingContainer, FullCalendar},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      schedules: [],

      creatingFrom: null,
      creatingTo: null,

      editing: null,
    }
  },

  computed: {
    calendarOptions() {
      return {
        plugins: [momentTimezonePlugin, timeGridPlugin, interactionPlugin, listPlugin],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek,timeGridDay,listWeek'
        },
        initialView: 'timeGridWeek',
        locale: 'en-GB',
        eventTimeFormat: {hour: '2-digit', minute: '2-digit', hour12: false},
        slotLabelFormat: {hour: '2-digit', minute: '2-digit', hour12: false},
        firstDay: 1,
        timeZone: 'Europe/Copenhagen',
        allDaySlot: false,
        slotEventOverlap: false,
        events: this.schedules.map(schedule => this.getEvent(schedule)),
        editable: true,
        selectable: true,
        eventClick: this.edit,
        eventDrop: this.update,
        eventResize: this.update,
        select: this.create,
        datesSet: this.datesSet,
      }
    },
  },

  methods: {
    load(from, to) {
      http.getList('/api/v2/content-article-flag-schedules', {
        'filter[portal_id]': this.portal.id,
        'filter[active_from]': from,
        'filter[active_to]': to,
      }).then(schedules => {
        this.schedules = schedules

        this.loading = false
      })
    },

    edit(event) {
      this.editing = this.schedules.find(schedule => schedule.id === event.event.id)

      $('#edit-article-flag-schedule-modal').modal('show')
    },

    datesSet(event) {
      this.load(moment(event.start).format('YYYY-MM-DD'), moment(event.end).format('YYYY-MM-DD'))
    },

    create(event) {
      this.creatingFrom = moment(event.start).format('YYYY-MM-DD HH:mm:ss')
      this.creatingTo = moment(event.end).format('YYYY-MM-DD HH:mm:ss')

      this.$refs.fullCalendar.getApi().unselect()

      $('#create-article-flag-schedule-modal').modal('show')
    },

    created(schedule) {
      this.schedules.push(schedule)

      this.$refs.fullCalendar.getApi().addEvent(this.getEvent(schedule))
    },

    updated(schedule) {
      const event = this.$refs.fullCalendar.getApi().getEventById(schedule.id)

      event.setStart(new Date(schedule.attributes.starts_at))

      event.setEnd(new Date(schedule.attributes.ends_at))
    },

    deleted(id) {
      this.$refs.fullCalendar.getApi().getEventById(id).remove()
    },

    update(event) {
      http.put('/api/v2/content-article-flag-schedules/' + event.event.id, {
        starts_at: moment(event.event.start).format('YYYY-MM-DD HH:mm:ss'),
        ends_at: moment(event.event.end).format('YYYY-MM-DD HH:mm:ss'),
      }).then(response => {
        this.schedules.splice(
            this.schedules.findIndex(schedule => schedule.id === event.event.id),
            1,
            response.data.data
        )

        notify.success('The schedule was updated')
      })
    },

    getEvent(schedule) {
      return {
        id: schedule.id,
        title: schedule.attributes.content_article_title,
        start: new Date(schedule.attributes.starts_at),
        end: new Date(schedule.attributes.ends_at),
        color: schedule.attributes.content_article_flag_color
      }
    }
  }
}
</script>
